/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { TableConfig, TableConfig$inboundSchema } from "./tableconfig.js";

/**
 * The configuration of a bulk edit view
 */
export type BulkEditView = {
  /**
   * Specifies the configuration of the Table Visualization in Equipment Browser
   */
  config: TableConfig;
};

/** @internal */
export const BulkEditView$inboundSchema: z.ZodType<
  BulkEditView,
  z.ZodTypeDef,
  unknown
> = z.object({
  config: TableConfig$inboundSchema,
});

export function bulkEditViewFromJSON(
  jsonString: string,
): SafeParseResult<BulkEditView, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BulkEditView$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BulkEditView' from JSON`,
  );
}
